import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

let editAutocomplete: google.maps.places.Autocomplete;

const componentEditForm = {
  edit_street_number_cp: 'short_name',
  edit_route_cp: 'long_name',
  edit_locality_cp: 'long_name',
  edit_administrative_area_level_1_cp: 'short_name',
  edit_postal_code_cp: 'short_name',
  edit_country_cp: 'short_name',
};

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesAutocompleteCpService {
  isAddressValid$ = new Subject<boolean>();
  isReset$ = new Subject<boolean>();

  validAddress(address) {
    let isValid = false;
    Object.keys(address).forEach((v) => {
      if (!address[v] && v !== 'address2') {
        isValid = true;
      }
    });
    return isValid;
  }

  initEditAutocomplete(country, input) {
    // Create the autocomplete object, restricting the search predictions to
    // geographical location types.

    if (!country) {
      country = ['us', 'ca'];
    }
    const options = {
      types: ['geocode'],
      componentRestrictions: { country },
    };

    // const input = this.googleAutocompleteEdit.nativeElement;
    editAutocomplete = new google.maps.places.Autocomplete(input, options);

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.
    editAutocomplete.setFields(['address_component']);

    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    editAutocomplete.addListener('place_changed', this.editFillInAddress);
  }

  editFillInAddress() {
    // Get the place details from the autocomplete object.
    const place = editAutocomplete.getPlace();

    const { address_components } = place;

    if (!address_components) {
      return;
    }

    (document.getElementById('edit-form-search-cp') as HTMLInputElement).hidden =
      true;
    (document.getElementById('edit-form-result-cp') as HTMLInputElement).hidden =
      false;
    (document.getElementById('edit_street_number_cp') as HTMLInputElement).value =
      null;

    setTimeout(() => {
      for (const component in componentEditForm) {
        if (component !== 'edit_street_number_cp') {
          (document.getElementById(component) as HTMLInputElement).value = '';
        }
      }

      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      let street_number;

      for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
        let addressType = component.types[0];
        if (
          addressType !== 'locality' &&
          addressType === 'sublocality_level_1'
        ) {
          addressType = 'locality';
        }

        if (componentEditForm[`edit_${ addressType }_cp`]) {
          let val = component[componentEditForm[`edit_${ addressType }_cp`]];

          if (
            addressType !== 'locality' &&
            addressType === 'sublocality_level_1'
          ) {
            val = component['long_name'];
          }

          if (addressType === 'street_number') {
            street_number = val || '';
          } else {
            if (addressType === 'route') {
              if (street_number) {
                val = `${ street_number } ${ val }`;
              }
            }
            (
              document.getElementById(`edit_${ addressType }_cp`) as HTMLInputElement
            ).value = val;
          }
        }
      }
    }, 100);
  }
}
